// export const NODE_API_BASE_URL = "http://54.209.91.44"//"http://54.209.91.44";"https://mcomp.etalyc.com";
export const NODE_API_BASE_URL = "https://mcomp.etalyc.com";
export const SOCKET_ENDPOINT = "https://mcomp.etalyc.com";
export const RECAPTCHA_KEY = "6Ldjf6gZAAAAAFZKuTHkTaMGxpvROavpF9STAFbE"; // test key 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
export const GOOGLE_ANALYTICS_KEY = "UA-141680573-1";